import * as processENV from '@/processENV';
const { VITE_XMPP_SOCKET_HOST } = processENV;

export const formatUserIdToJid = (userId, chatType = 'chat') => {
   if (!userId || userId.includes(`${VITE_XMPP_SOCKET_HOST}`) || userId.includes('@')) return userId;
   return chatType === 'chat' ? `${userId}@${VITE_XMPP_SOCKET_HOST}` : `${userId}@mix.${VITE_XMPP_SOCKET_HOST}`;
};

export const formatJidToUserId = jid => {
   if (!jid?.includes(`${VITE_XMPP_SOCKET_HOST}`)) return jid;
   return jid.split('@')[0];
};

export const isGroupChat = jid => jid.includes('@mix');

export const getChatType = jid => (isGroupChat(jid) ? 'group' : 'chat');

export const normalizeJid = jid => {
   if (!jid) return jid;
   return jid.split('/')[0];
};
